/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

Sockets = {
    socket: false,
    init: function () {
        Sockets.socket = io.connect("https://" + Sockets.hostname);

        Sockets.socket.on("connected-to-socket", function () {
            var evt = $.Event('connected-to-socket');
            $(window).trigger(evt);
        });
    }
};

$(document).ready(function () {
    // init must be on master template because of hostname and port variables
    // Sockets.init();
});
